// Copyright The Perses Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { PersesColor } from './types';

export const red: PersesColor = {
  50: '#FDEDED',
  100: '#FBDADA',
  150: '#F9C8C8',
  200: '#F7B5B5',
  300: '#F29191',
  400: '#EE6C6C',
  500: '#EA4747',
  600: '#BD3939',
  700: '#902B2B',
  800: '#621D1D',
  850: '#4C1616',
  900: '#350F0F',
  950: '#1F0808',
};
